import s from '../allservices.jsx'
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';
const getUseridService = actionCallback => {
    const cardnumber = localStorage.getItem("cardnumber")
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let traceId = getClientId();
    let appids = localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'

    fetch(plink + s.get_userid + "/" + cardnumber + "/"+ appids , {
        headers: new Headers({
            'Content-Type': 'application/json',
             'X-Trace-Id': traceId,
             'X-KlickEx-Client':buildClientHeader(),
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else {
                res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getUseridService;


// WEBPACK FOOTER //
// ./src/services/components/get_userid.jsx